<template>
  
  <div class="Table">
    
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Dane tabelaryczne
        </p>
        <a href="#" class="card-header-icon" aria-label="more options">
          <span class="icon">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <div class="content">
          <table id="tableplace" class="display compact" style="width:100%">
            <thead>
              <tr>
                  <th>Data</th>
                  <th>1.CO zasilanie 1</th>
                  <th>2.CO zasilanie 2</th>
                  <th>3.CO powrót 1</th>
                  <th>4.CO powrót 2</th>
                  <th>5.CW na budynek</th>
                  <th>6.CW na zasobnik z kotła</th>
                  <th>7.CW cyrkulacja</th>
                  <th>8.Kol-zejście glikolu</th>
                  <th>9.Kol-cyrkulacja</th>
                  <th>10.Kol-CWZ wymiennika</th>
              </tr>
            </thead>
            <tbody>
              
            </tbody>
          </table>
          
          
        </div>
      </div>
      
      
    </div>
    
   
  </div>
</template>

<script>


//import $ from 'jquery';
//require('jquery');

//require("datatables.net");

var $ = require('jquery');
//var jQuery = $;
//window.jQuery = $;
//var jquery = $;
require('datatables.net');
require('datatables.net-bs4');

import 'datatables.net/js/jquery.dataTables'
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';




export default {
  name: 'Table',
  props: {
    
    
  },
  data() {
    return {
      table: "",
      limits: []
    }
  },
  mounted () {

    let vue = this;

    this.$store.dispatch('getLimits')
    .then(response => {
      
      vue.limits = response[0];
      vue.buildTable();
    })
    .catch(error => {
        console.log(error)
        return error
    });
    
    
    

  },
  computed: {

    
  },
  watch: {
    
  },
  updated() {
    
    
  },
  methods: {
    buildTable(){
     // console.log(this.table)
      let vue = this;
      if (this.table != undefined) {
        //this.table.destroy();
      }

      this.table = $('#tableplace').DataTable({
  				"processing": true,
  				"serverSide": true,
  				"ajax": this.$store.getters.hostAPI + "/GetTableData.php",
  				"order": [[0, "desc"]],
          "dom": "<f<t>ip>",
  				"language": {
  					"url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Polish.json"
  				}, 
          "columns": [
  					{
  						"data": "date"
  					}, 
            {
  						"data": "t0",
              render: function(data, type) {

                if (data > vue.limits.t0_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t0_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					}, 
            {
  						"data": "t1",
              render: function(data, type) {

                if (data > vue.limits.t1_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t1_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					}, 
            {
  						"data": "t2",
              render: function(data, type) {

                if (data > vue.limits.t2_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t2_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					}, 
            {
  						"data": "t3",
              render: function(data, type) {

                if (data > vue.limits.t3_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t3_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					}, 
            {
  						"data": "t4",
              render: function(data, type) {

                if (data > vue.limits.t4_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t4_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					}, 
            {
  						"data": "t5",
              render: function(data, type) {

                if (data > vue.limits.t5_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t5_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					},
            {
  						"data": "t6",
              render: function(data, type) {

                if (data > vue.limits.t6_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t6_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					},
            {
  						"data": "t7",
              render: function(data, type) {

                if (data > vue.limits.t7_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t7_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					},
            {
  						"data": "t8",
              render: function(data, type) {

                if (data > vue.limits.t8_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t8_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					},
            {
  						"data": "t9",
              render: function(data, type) {

                if (data > vue.limits.t9_max){
                  return "<span style=\"color:tomato;\">" + data + "</span>";
                }
                if (data < vue.limits.t9_min){
                  return "<span style=\"color:#3273dc;\">" + data + "</span>";
                }

                return data
              }
  					}
                    
			      ]
  			});



    }
      
      
  },
}
</script>


<style scoped>
  .card{
    margin-top: 10px;
  }
  .card .card-content{
    background-color: #333 !important;
  }
  .card .card-footer{
    background-color: #333 !important;
  }
  table td {
    color: white  !important;
  }
  table thead th {
    color: white !important;
  }
  table.dataTable{
    color: white;
  }
  table td .red{
    color: tomato !important;
  }
  .blue{
    color: #3366cc;
  }
  .dataTables_info{
    max-width: 200px !important;
  }
  .dataTables_paginate{
    float:left !important;
  }
  
  
  
  
</style>
